<template>
  <div v-if="if_time_out">
    <div class="player">
      <video ref='Player' id="video-stream"  class="video-js vjs-big-play-centered" controls></video> 
    </div>
  </div>
</template>

<script>
  import axios from "axios";
  import videojs from 'video.js';
  import videojsPlaylist from 'videojs-playlist'
  videojs.registerPlugin('videojs-playlist', videojsPlaylist);

  export default {

    name: "GSCApiComponent",

    props: ['update_component'],

    data () {
      return {
        if_time_out: true,
        player: null,
        stream:'',
        files:'',
        sec:'',
        type:'',
        hls_stream:'',
        // noise: noise,       //devel
        noise: 'https://golden-eye.com.ua/media/noise.mp4', //prod
        // api_url: 'http://127.0.0.1:8000/ext-api/get-ext-stream',  //devel
        api_url: '/api/ext-api/get-ext-stream',  //prod
      }
    },

    mounted() {
      this.stream = this.$route.query.stream
      this.sec = this.$route.query.sec
      this.type = this.$route.query.type
      this.check_sec()     
    },

    methods: {

      new_connect () {
        this.$emit('end_playlist_api')
      },


      check_sec(){
        if (this.update_component > 0) {
          this.stream_player()
        } else {

          let body = {
            'sec':this.sec,
          }
          axios({
              method: "post",
              url: this.api_url,
              data: body,
              headers: {'Content-Type':'application/json'},
            })
            .then((response) => {
              if (response.data == 'time_out') {
                this.if_time_out = false
                console.log('time_out')
                return 'time_out'
              } else {
                this.stream_player()
              }
            })
        }
      },

      async get_stream () {
        let body = {
          'stream':this.stream,
          // 'sec':this.sec,
          'type':this.type,
          'live_stream': '',
        }
        return axios({
            method: "post",
            url: this.api_url,
            data: body,
            headers: {'Content-Type':'application/json'},
          })
          .then((response) => {
            this.hls_stream = response.data.ext_hls_url
            return this.hls_stream
          })
          .catch(() => {
            return 'error_stream'
          })
      },


      async stream_player () {
        self = this
        await this.get_stream()
        this.player = videojs('video-stream', {
          controls: true,
          fluid: true,
          fill: true,
          responsive: true,
          errorDisplay: false,
          aspectRatio: '16:10',
          autoplay: true,
          muted: true,
          sources: [
            {
              src: this.hls_stream,
              type: "application/x-mpegURL"
            }
          ]
        })

        await this.player.on('error', function(){
          if (this.player().error()) {
            self.files_player()
          }
        })
      }, 

      async get_video_files() {
        let body = {
          'stream':this.stream,
          'type':this.type,
          'error_stream':''
        }
        return axios({
            method: "post",
            url: this.api_url,
            data: body,
            headers: {'Content-Type':'application/json'},
          })
          .then((response) => {
            if (response.data == 'not_camera'){
              console.log('error_camera')
              return 'error_camera'
            }
            else {
              this.files = response.data
              return this.files
            }

          })
          .catch(() => {
            self.noise_err()
          })
      },
      
      async files_player() {
        self = this
        await this.get_video_files()
        let local_playlist = []

        for (let url in this.files) {
          local_playlist.push({
            sources: [{
              src: this.files[url],
              type: 'video/mp4'
            }]
          })
        }

        this.player.playlist(local_playlist)
        this.player.playlist.autoadvance(0);
        this.player.responsive(true);
        this.player.fill(true);
        this.player.fluid(true);

        this.player.on('error', function(){
          if (this.player().error()) {
            console.log('error_urls')
            setTimeout(self.noise_err, 1000);
          }
        })

        this.player.ready(function() {
          this.on("ended", function(){ 
            if (self.player.playlist.currentIndex() === 1) {
              self.new_connect()
            }
          });
        });

      },

      noise_err () {
        this.player.src({src: this.noise, type: 'video/mp4'})     
        setTimeout(this.new_connect, 9000);
      }
    },

    beforeUnmount() {
      this.player.dispose()
    } 

  }

</script>